const range = (from: number, size: number) => {
  return Array(size)
    .fill(from)
    .map((x, y) => x + y);
};

export default range;
